import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Mail } from 'lucide-react';
import { newsletterAPI } from '../services/api';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState(''); // 'success', 'error', or ''

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    try {
      await newsletterAPI.subscribe(email);
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus(''), 3000);
    } catch (error) {
      setStatus('error');
      console.error('Newsletter subscription error:', error);
      setTimeout(() => setStatus(''), 3000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <h3 className="heading-3">Stay in the loop</h3>
          <p className="body-small" style={{ marginTop: '12px', marginBottom: '20px' }}>
            Get the latest motorsport news, exclusive content, and new releases.
          </p>
          <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
              required
            />
            <button type="submit" className="btn-primary">
              Subscribe
            </button>
          </form>
        </div>

        {/* Footer Grid */}
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-column">
            <div className="footer-logo">
              <span className="logo-text">RACE377</span>
            </div>
            <p className="body-small" style={{ marginTop: '16px', maxWidth: '250px' }}>
              Motorsport lifestyle brand combining magazine, merch, and car culture.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Explore</h4>
            <ul className="footer-links">
              <li><Link to="/news">News</Link></li>
              <li><Link to="/categories">Categories</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="footer-column">
            <h4 className="footer-heading">Series</h4>
            <ul className="footer-links">
              <li><Link to="/categories/formula-1">Formula 1</Link></li>
              <li><Link to="/categories/wec">WEC</Link></li>
              <li><Link to="/categories/imsa">IMSA</Link></li>
              <li><Link to="/categories/indycar">IndyCar</Link></li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Connect</h4>
            <div className="social-links">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={24} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Youtube size={24} />
              </a>
              <a href="mailto:hello@race377.com" className="social-link">
                <Mail size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p className="caption">© 2026 Race377. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;